import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import R, { path } from 'ramda';

import Navbar from 'react-bulma-companion/lib/Navbar';
import Container from 'react-bulma-companion/lib/Container';
import Image from 'react-bulma-companion/lib/Image';
import Title from 'react-bulma-companion/lib/Title';

import logo from "_assets/images/abramsonLogo.png";

export default function Navigation({ pathname }) {
  const { user } = useSelector(R.pick(['user']));

  const { path, url } = useRouteMatch();

  const [auth, setAuth] = useState(!R.isEmpty(user));

  const nameMap = {
    "intake": "Intake"
  }

  const [isActive, setisActive] = useState(false)

  useEffect(() => {
    setAuth(!R.isEmpty(user));
    console.log(location.href);
  }, [user.username]);

  return (
    <Navbar fixed="top" shadow>
      <Container className="justify-between">
        <Navbar.Brand>
          <Navbar.Item style={{ padding: 0 }}>
            <Navbar.Burger
              className={`navbar-burger burger ${isActive ? 'is-active' : ''}`}
              aria-label='menu'
              aria-expanded='false'
              data-target='navbarBasicExample'
              onClick={() => {
                setisActive(!isActive)
              }}>
              <span aria-hidden='true'></span>
              <span aria-hidden='true'></span>
              <span aria-hidden='true'></span>
            </Navbar.Burger>
          </Navbar.Item>
          <Navbar.Item
            aria-label="main navigation"
          >
            <Image className="logo">
              <Image.Content
                className="logo-image"
                alt="Abramson Labor Group"
                src={logo}
                draggable="false"
              />
            </Image>
          </Navbar.Item>
          <Navbar.Item
            aria-label="main mobile-spacer" className="mobile-spacer" style={{width: "39px"}}
          >
          </Navbar.Item>
        </Navbar.Brand>
        <div className='navbar-title'>
          <Title>{pathname.includes('/s/') && nameMap[pathname.split('/')[2]]}</Title>
        </div>
        <div id="algNavDrawer" className={`navbar-menu ${isActive ? 'is-active' : ''}`}>
          <Navbar.End>
            <Navbar.Item>
              <a href='tel:2137994820' style={{ fontWeight: "bold", fontSize: "1.4em" }} className='navbar-item'>
               (213) 799-4820
              </a>
            </Navbar.Item>
          </Navbar.End>
        </div>
      </Container>
    </Navbar>
  );
}

Navigation.propTypes = {
  pathname: PropTypes.string.isRequired,
};